export default "__VITE_ASSET__dLZZkx4t__"